import React, { Component } from 'react'
import Dialog from "@material-ui/core/Dialog"
import './AccountEdit.scss'
import i18n from '../../../i18n';
import axios from "axios";
import { GetBaseUrl } from '@/utils/ConfigHelper'

class AccountEdit extends Component {

    constructor(props) {
        super(props)
        this.state = {
            dialogType: "changeAccount",
            isOpenOneBtnDialog: false,
            nickname: '',
            password: '',
            nicknameAlertMessage: '',
            passwordAlertMessage: '',
            nicknameValid: true,
            passwordValid: false
        }
    }

    isValidPassword = password => /^(?=.*[a-zA-Z])(?=.*[0-9]).{8,32}$/.test(String(password).toLowerCase())

    componentWillReceiveProps(nextProps) {
        const { nickname } = this.state

        if (nextProps.accountData.displayName !== nickname) {
            this.setState({ nickname: nextProps.accountData.displayName })
        }
    }

    handleChangeAccountButton = async () => {
        const { nickname, password } = this.state
        const { getAccountData, accountData } = this.props
        const token = localStorage.getItem("token")
        const body = {}

        if (nickname && nickname !== accountData.displayName) body.displayName = nickname
        if (password) body.password = password

        try {
            await axios.patch(`${GetBaseUrl()}/apis/users/business/account/${accountData._id}`, body, { headers: { Authorization: `Bearer ${token}` } })
    
            getAccountData()
            this.handleCloseChangeAccountDialog()
            alert(i18n.t("onebtndialog.changeAccount.dialogBodyText1"))
            
        } catch (error) {
            alert(i18n.t("onebtndialog.severError.dialogBodyText1"))
        }
    }

    handleChangeNicknameInput = e => {
        const { accountData } = this.props
        const { password } = this.state
        const { value } = e.target

        if ( value === accountData.displayName ) {
           this.checkValidPassword(password)
           this.setState ({ passwordValid: false })
        }  
        else if(password.length === 0) {
            this.setState ({ passwordAlertMessage: null, passwordValid: true })
        }

        this.setState({
            [e.target.name]: value,
        })
    }

    handleBlurNicknameInput = async e => {
        const { value } = e.target
        const { accountData } = this.props
        let alertString = null
        let nicknameValid = false

        try {
            if (!value || value.length === 0) {
                alertString = i18n.t("web.business.account.nickname.check")
            } 
            else if (value !== accountData.displayName) {
                const response = await axios.get(`${GetBaseUrl()}/api/auth/is-exist-email?email=${value}`)
                if (response.data.isExist) {
                    alertString = i18n.t("web.business.account.duplicate")
                } 
                else if (value.includes(' ')) {
                    alertString = i18n.t("web.business.account.space")
                }
            } 

            if (alertString === null) {
                nicknameValid = true
            } 
            else {
                nicknameValid = false
            }

        } catch (error) {
            console.log(error)
        }
        this.setState({ nicknameAlertMessage: alertString, nicknameValid })
    }

    handleChangePasswordInput = e => {
        const { value } = e.target
        this.checkValidPassword(value)
        this.setState({ password: value })
    }

    handleBlurPasswordInput = async e => {
        const { value } = e.target
        this.checkValidPassword(value)
    }

    checkValidPassword = value => {
        const { accountData } = this.props
        const { nickname } = this.state
        let alertString = null
        let passwordValid = false

        if ((value && value.length > 0) && !this.isValidPassword(value)) {
            alertString = i18n.t("web.business.wrong.password")
        }
        if (nickname === accountData.displayName) {
            if (!value || value.length === 0) {
                alertString = i18n.t("web.business.account.password.check")
            }
        }

        if (alertString === null) {
            passwordValid = true
        } 
        else {
            passwordValid = false
        }

        this.setState({ passwordAlertMessage: alertString, passwordValid })
    }

    handleCloseChangeAccountDialog = () => {
        this.props.onClose()

        this.setState({
            password: '',
            passwordAlertMessage: '',
            nicknameAlertMessage: '',
            nicknameValid: true,
            passwordValid: false
        })
    }

    render() {
        const { open } = this.props
        const {
            nickname,
            password,
            passwordAlertMessage,
            nicknameAlertMessage,
            nicknameValid,
            passwordValid
        } = this.state
        const isValidBtn = nicknameValid && passwordValid

        return (
            <Dialog open={open} onClose={this.handleCloseChangeAccountDialog} maxWidth={false}>
                <div className='account-change-container'>
                    <div className='account-change-title'>{i18n.t("web.business.account.change.data")}</div>
                    <div className='account-change-close'>
                        <img src='https://front.videomonster.com/images-7cuytg20/web/newgallery/DialogClose.svg' onClick={this.handleCloseChangeAccountDialog} alt='close' />
                    </div>
                    <div className='account-change-body'>
                        <input
                            className='nickname'
                            type='text'
                            name='nickname'
                            value={nickname}
                            placeholder={i18n.t("web.business.account.placeholder.nickname")}
                            spellCheck="false"
                            onChange={this.handleChangeNicknameInput}
                            onBlur={this.handleBlurNicknameInput}
                        />
                        {
                            nicknameAlertMessage
                                ?
                                <div className='input-bottom-text'>{nicknameAlertMessage}</div>
                                :
                                <div className='spacer'></div>
                        }
                        <input
                            className='password'
                            type='password'
                            name='password'
                            value={password}
                            placeholder={i18n.t("web.business.account.placeholder.password")}
                            spellCheck="false"
                            onChange={this.handleChangePasswordInput}
                            onBlur={this.handleBlurPasswordInput}
                        />
                        {
                            passwordAlertMessage
                                ?
                                <div className='input-bottom-text'>{passwordAlertMessage}</div>
                                :
                                <div className='spacer'></div>
                        }
                    </div>
                    <div className='account-change-button'>
                        <div className={`change-button ${isValidBtn ? 'active' : ''}`} onClick={() => isValidBtn && this.handleChangeAccountButton()}>{i18n.t("web.business.account.change")}</div>
                        <div className='cancel-button' onClick={this.handleCloseChangeAccountDialog}>{i18n.t("web.business.account.change.cancel")}</div>
                    </div>
                </div>
            </Dialog>
        )
    }
}

export default AccountEdit